<template>
  <div class="overlay" @click.self="$emit('fechar')">
    <div class="modal-filtros">
      <div class="modal-header">
        <span class="modal-label">Filtros Notícias</span>
        <button class="btn-fechar-modal" @click="$emit('fechar')">
          ×
        </button>
      </div>

      <div class="modal-corpo">
        <div class="coluna">
          <p class="coluna-titulo">Data Inicial:</p>
          <input type="date" v-model="filtros.dataInicial" class="input-data" />
        </div>

        <div class="coluna">
          <p class="coluna-titulo">Data Final:</p>
          <input type="date" v-model="filtros.dataFinal" class="input-data" />
        </div>
      </div>

      <div class="modal-rodape">
        <button class="btn-limpar" @click="limparFiltros">
          Limpar filtros
        </button>
        <button class="btn-filtrar" @click="aplicarFiltros">
          Filtrar
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import { useRouter, useRoute } from "vue-router";

const props = defineProps({
  filtrosIniciais: {
    type: Object,
    default: () => ({
      dataInicial: "",
      dataFinal: "",
    }),
  },
});

const emit = defineEmits(["fechar"]);

const router = useRouter();
const route = useRoute();

const filtros = ref({
  dataInicial:
    route.query.dataInicial || props.filtrosIniciais?.dataInicial || "",
  dataFinal: route.query.dataFinal || props.filtrosIniciais?.dataFinal || "",
});

watch(
  () => [route.query.dataInicial, route.query.dataFinal],
  ([novaInicial, novaFinal]) => {
    filtros.value.dataInicial = novaInicial || "";
    filtros.value.dataFinal = novaFinal || "";
  }
);

function limparFiltros() {
  const query = { ...route.query };
  delete query.dataInicial;
  delete query.dataFinal;
  delete query.page;

  filtros.value = { dataInicial: "", dataFinal: "" };

  router.push({ query });
  emit("fechar");
}

function aplicarFiltros() {
  const query = { ...route.query };

  if (filtros.value.dataInicial) {
    query.dataInicial = filtros.value.dataInicial;
  } else {
    delete query.dataInicial;
  }

  if (filtros.value.dataFinal) {
    query.dataFinal = filtros.value.dataFinal;
  } else {
    delete query.dataFinal;
  }

  delete query.page;

  router.push({ query });
  emit("fechar");
}
</script>

<style scoped>
.modal-corpo {
  display: flex;
  justify-content: space-around;
  background: var(--branco);
  gap: 16px;
}

.coluna {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
}

p {
  margin-bottom: 0;
}

.coluna-titulo {
  font-weight: 700;
  font-size: 0.9rem;
  color: var(--preto);
}

.input-data,
.select-unidade {
  padding: 10px;
  border: 1px solid var(--cinza-medio);
  border-radius: 8px;
  font-size: 0.9rem;
  outline: none;
  width: 100%;
  background: var(--branco);
}

.select-unidade {
  padding-right: 32px;
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23563578' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
}

.input-data:focus,
.select-unidade:focus {
  border-color: var(--roxo-medio);
}


.btn-limpar {
  border: 2px solid var(--roxo-medio);
  background: var(--branco);
  color: var(--roxo-medio);
  border-radius: 10px;
  padding: 8px 28px;
  font-weight: 600;
  cursor: pointer;
  font-size: 0.9rem;
}

.btn-limpar:hover {
  background: var(--roxo-superficie);
}

.btn-filtrar {
  background: var(--roxo-primario);
  color: var(--branco);
  border: none;
  border-radius: 10px;
  padding: 8px 28px;
  font-weight: 600;
  cursor: pointer;
  font-size: 0.9rem;
}

.btn-filtrar:hover {
  background: var(--roxo-medio);
}

@media (max-width: 600px) {
  .modal-corpo {
    flex-direction: column;
  }
}
</style>
